import { AxiosError } from 'axios';
import classnames from 'classnames';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { updateUserProfileAction } from '../../../../actions';
import styles from './resetPassword.module.scss';

interface DispatchProps {
  // eslint-disable-next-line @typescript-eslint/ban-types
  updateUserProfileAction: Function;
}

const ResetPassword = ({ updateUserProfileAction }: DispatchProps) => {
  const [resetSent, setResetSent] = useState(false);

  const resetPassword = async () => {
    if (!resetSent) {
      try {
        setResetSent(true);
        await updateUserProfileAction({ password: 'resetpw' });
        toast.success('Email reset password sent.');
      } catch (error) {
        toast.success(error as AxiosError);
        setResetSent(true);
      }
    }
  };
  return (
    <div className={styles.root}>
      <h4 className="mb-5 pageTitle">Change Password</h4>
      <p className={classnames('mb-5', styles.text)}>
        Passwords are changed using a password reset email. Please click the
        button below and an email will be sent to you.
      </p>
      <Button onClick={resetPassword} disabled={resetSent}>
        Reset Password
      </Button>
    </div>
  );
};

export default connect<null, DispatchProps>(null, {
  updateUserProfileAction,
})(ResetPassword);
